
// src/reducers/index.js

import { combineReducers } from 'redux'
import routerReducer from './react-router-redux'
import { reducer as uiReducer } from 'redux-ui'
import mediaQueryReducer from './media-query'

import alertMessageReducer from './alert-message-reducer'
import accountReducer from './account-reducer'
import activityReportReducer from './activity-report-reducer'
import announceReducer from './announce-reducer'
import attachmentsReducer from './attachments-reducer'
import buildNoReducer from './build-no-reducer'
import chatMessagesReducer from './chat-messages-reducer'
import chatRoomsReducer from './chat-rooms-reducer'
import commentsReducer from './comments-reducer'
import diariesReducer from './diaries-reducer'
import diaryTemplatesReducer from './diary-templates-reducer'
import diaryKpiReducer from './diary-kpi-reducer'
import favoriteReducer from './favorite-reducer'
import blockReducer from './block-reducer'
import groupsReducer from './groups-reducer'
import kpiChartReducer from './kpi-chart-reducer'
import kpiReducer from './kpi-reducer'
import likesReducer from './likes-reducer'
import pinsReducer from './pins-reducer'
import notificationsReducer from './notifications-reducer'
import organizationsReducer from './organizations-reducer'
import preservedQueriesReducer from './preserved-queries-reducer'
import savedDiariesReducer from './saved-diaries-reducer'
import sessionsReducer from './sessions-reducer'
import subDiariesReducer from './sub-diaries-reducer'
import subscribeReducer from './subscribe-reducer'
import templatesReducer from './templates-reducer'
import uploadFileReducer from './upload-file-reducer'
import uploadVideoReducer from './upload-video-reducer'
import userReducer from './user-reducer'
import usersReducer from './users-reducer'
import sidebarReducer from './sidebar-reducer'
import rightSidebarReducer from './right-sidebar-reducer'
import googleApiReducer from './google-api-reducer'
import outlookApiReducer from './outlook-api-reducer'
import diaryFormReducer from './diary-form-reducer'
import editDiaryReducer from './edit-diary-reducer'
import groupSettingsReducer from './group-settings-reducer'
import userSettingsReducer from './user-settings-reducer'
import socketReducer from './socket-reducer'
import nativeRouterReducer from './native-router'
import productTourReducer from './product-tour-reducer'
import registrationUrlReducer from './registration-url-reducer'
import accountOtherMembersCountReducer from './account-other-members-count-reducer'
import urlInfoReducer from './url-info-reducer'
import imagesViewReducer from './images-view-reducer'
import translateReducer from './translate-reducer'
import dashboardReducer from './dashboard-reducer'
import submissionSchedulesReducer from './submission-schedules-reducer'
import reportReducer from './report-reducer'
import diaryReportReducer from './diary-report-reducer'
import divisionsReducer from './divisions-reducer'
import divisionSettingsReducer from './divisions-settings-reducer'
import divisionGroupManagerReducer from './divisions-group-manager-reducer'
import menusReducer from './menus-reducer'
import lambdaApiReducer from './lambda-api-reducer'
import reviewSettingReducer from './review-setting-reducer'
import reactChatReducer from './react-chat-reducer'
import showTimeStampSettingReducer from './show-timestamp-setting-reducer'

export default combineReducers({
  //logger: (state = {}, action)=> { console.log('ACTION', action.type); return state; },
  //logger: (state = {}, action = {})=> { global.nativeLoggingHook(`ACTION: ${action.type}`, 1); return state; },
  alertMessage: alertMessageReducer,
  routing: routerReducer,
  ui: uiReducer,
  media: mediaQueryReducer,
  account: accountReducer,
  activityReport: activityReportReducer,
  alertMessage: alertMessageReducer,
  announce: announceReducer,
  attachments: attachmentsReducer,
  buildNo: buildNoReducer,
  chatMessages: chatMessagesReducer,
  chatRooms: chatRoomsReducer,
  comments: commentsReducer,
  diaries: diariesReducer,
  diaryTemplates: diaryTemplatesReducer,
  diaryKPI: diaryKpiReducer,
  favorite: favoriteReducer,
  block: blockReducer,
  groups: groupsReducer,
  kpiChart: kpiChartReducer,
  kpi: kpiReducer,
  likes: likesReducer,
  pins: pinsReducer,
  notifications: notificationsReducer,
  organizations: organizationsReducer,
  preservedQueries: preservedQueriesReducer,
  savedDiaries: savedDiariesReducer,
  sessions: sessionsReducer,
  subDiaries: subDiariesReducer,
  subscribe: subscribeReducer,
  templates: templatesReducer,
  uploadFile: uploadFileReducer,
  uploadVideo: uploadVideoReducer,
  user: userReducer,
  users: usersReducer,
  sidebar: sidebarReducer,
  rightSidePage: rightSidebarReducer,
  googleApi: googleApiReducer,
  outlookApi: outlookApiReducer,
  diaryForm: diaryFormReducer,
  editDiary: editDiaryReducer,
  groupSettings: groupSettingsReducer,
  userSettings: userSettingsReducer,
  socket: socketReducer,
  routes: nativeRouterReducer,
  productTour: productTourReducer,
  registrationUrl: registrationUrlReducer,
  accountOtherMembersCount: accountOtherMembersCountReducer,
  urlInfo: urlInfoReducer,
  imagesView: imagesViewReducer,
  translate: translateReducer,
  dashboard: dashboardReducer,
  submissionSchedules:  submissionSchedulesReducer,
  reportReducer: reportReducer,
  diaryReport: diaryReportReducer,
  divisions: divisionsReducer,
  divisionSettings: divisionSettingsReducer,
  divisionGroupManagers:divisionGroupManagerReducer,
  menus: menusReducer,
  lambdaApi: lambdaApiReducer,
  reviewSetting: reviewSettingReducer,
  reactChat: reactChatReducer,
  showTimeStamp: showTimeStampSettingReducer
})



// WEBPACK FOOTER //
// ./src/reducers/index.js